import React, { useState } from 'react';
import './TeacherEvaluation.css';

const TeacherEvaluation = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleBack = () => {
    window.history.back();
  };

  const handleExportReport = () => {
    console.log('Exporting report...');
  };

  return (
    <div className="teacher-evaluation-container">
      {/* Header */}
      <div className="te-header">
        <div className="te-search-container">
          <div className="te-search-box">
            <svg className="te-search-icon" viewBox="0 0 24 24">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
            <input
              type="text"
              placeholder="Search keywords..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="te-search-input"
            />
          </div>
          <div className="te-enter-button">
            <svg className="te-enter-icon" viewBox="0 0 16 16">
              <path d="M8 1L15 8L8 15M15 8H1" stroke="currentColor" strokeWidth="2" fill="none"/>
            </svg>
            <span>Enter</span>
          </div>
        </div>
        <button className="te-back-button" onClick={handleBack}>
          <svg className="te-back-icon" viewBox="0 0 24 24">
            <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" fill="none"/>
          </svg>
          <span>Back</span>
        </button>
      </div>

      {/* Title */}
      <h1 className="te-title">Teacher Evaluation</h1>

      {/* Navigation Tabs */}
      <div className="te-nav-tabs">
        <div className="te-tab active">
          <svg className="te-tab-icon" viewBox="0 0 24 24">
            <path d="M3 3H21V21H3V3ZM5 5V19H19V5H5Z" fill="currentColor"/>
            <path d="M7 7H17V9H7V7ZM7 11H17V13H7V11ZM7 15H13V17H7V15Z" fill="currentColor"/>
          </svg>
          <span>Overview</span>
        </div>
        <div className="te-tab">
          <svg className="te-tab-icon" viewBox="0 0 24 24">
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" fill="none"/>
          </svg>
          <span>Scholarship/Research</span>
        </div>
        <div className="te-tab">
          <svg className="te-tab-icon" viewBox="0 0 24 24">
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" fill="none"/>
          </svg>
          <span>Teaching</span>
        </div>
        <div className="te-tab">
          <svg className="te-tab-icon" viewBox="0 0 24 24">
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" fill="none"/>
          </svg>
          <span>Service</span>
        </div>
        <div className="te-tab">
          <svg className="te-tab-icon" viewBox="0 0 24 24">
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" fill="none"/>
          </svg>
          <span>Professional Credentials</span>
        </div>
        <div className="te-tab">
          <svg className="te-tab-icon" viewBox="0 0 24 24">
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" fill="none"/>
          </svg>
          <span>Career</span>
        </div>
      </div>

      {/* Main Content Grid */}
      <div className="te-main-grid">
        {/* Profile Card - Top Left */}
        <div className="te-profile-card">
          <div className="te-profile-avatar">
            <span className="te-avatar-initials">JD</span>
          </div>
          <div className="te-profile-info">
            <h3 className="te-profile-name">Dr. Jane Doe</h3>
            <p className="te-profile-title">Associate Professor, Department of Economics</p>
            <p className="te-profile-details">Faculty Since: 2017 | Last Evaluation: March, 2024</p>
          </div>
          <button className="te-export-button" onClick={handleExportReport}>
            <svg className="te-export-icon" viewBox="0 0 24 24">
              <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z" fill="currentColor"/>
            </svg>
            <span>Export Report</span>
          </button>
        </div>

        {/* Overall Score Card - Top Middle */}
        <div className="te-score-card">
          <div className="te-score-header">
            <span>Overall Evaluation Score</span>
          </div>
          <div className="te-score-value">4.2/5</div>
        </div>

        {/* Metrics Grid - Right Side */}
        <div className="te-metrics-container">
          <div className="te-metrics-grid">
            {/* Teaching Effectiveness */}
            <div className="te-metric-card te-teaching">
              <div className="te-metric-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" fill="none"/>
                </svg>
              </div>
              <div className="te-metric-content">
                <h4>Teaching Effectiveness</h4>
                <div className="te-metric-score">4.5/5</div>
                <p className="te-metric-comparison">(+0.3 vs peers)</p>
              </div>
            </div>

            {/* Research Output */}
            <div className="te-metric-card te-research">
              <div className="te-metric-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z" fill="currentColor"/>
                </svg>
              </div>
              <div className="te-metric-content">
                <h4>Research Output</h4>
                <div className="te-metric-score">4.2/5</div>
                <p className="te-metric-comparison">(+0.1 vs peers)</p>
              </div>
            </div>

            {/* Service Contribution */}
            <div className="te-metric-card te-service">
              <div className="te-metric-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" fill="none"/>
                </svg>
              </div>
              <div className="te-metric-content">
                <h4>Service Contribution</h4>
                <div className="te-metric-score">3.8/5</div>
                <p className="te-metric-comparison">(-0.2 vs peers)</p>
              </div>
            </div>

            {/* Grant Funding */}
            <div className="te-metric-card te-grants">
              <div className="te-metric-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" fill="none"/>
                </svg>
              </div>
              <div className="te-metric-content">
                <h4>Grant Funding</h4>
                <div className="te-metric-score">4.0/5</div>
                <p className="te-metric-comparison">(avg. with peers)</p>
              </div>
            </div>
          </div>
        </div>

        {/* Radar Chart - Bottom Left */}
        <div className="te-radar-chart">
          <h3>Scholarship/Research</h3>
          <div className="te-chart-container">
            <div className="te-pentagon-chart">
              <div className="te-pentagon">
                <div className="te-pentagon-fill"></div>
              </div>
              <div className="te-score-labels">
                <div className="te-score-label" style={{ top: '15%', left: '15%' }}>15%</div>
                <div className="te-score-label" style={{ top: '100%', left: '50%' }}>100%</div>
                <div className="te-score-label" style={{ top: '78%', left: '50%' }}>78%</div>
                <div className="te-score-label" style={{ top: '87%', left: '50%' }}>87%</div>
                <div className="te-score-label" style={{ top: '90%', left: '50%' }}>90%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherEvaluation;
